import ElstrIo from "../ElstrIo";

interface LanguageLoadParameters {
  file: string;
  lang: string;
}

interface LanguageRegisterParameters {
  module: any;
}

export default class ElstrLanguageService {
  /**
   * Funktion fur das Laden einer Sprache
   * @param languageCode
   * @param file
   */
  static async load(languageCode: string, file = ""): Promise<any> {
    try {
      return await ElstrIo.requestJsonRpc<LanguageLoadParameters, any>(
        "ELSTR_LanguageServer",
        "load",
        {
          file,
          lang: languageCode.toLowerCase(),
        },
      );
    } catch (e) {
      console.log(e);
      return new Error(String(e));
    }
  }

  static async registerModule(module: any) {
    try {
      return await ElstrIo.requestJsonRpc<LanguageRegisterParameters, any>(
        "ELSTR_LanguageServer",
        "registerModule",
        {
          module,
        },
      );
    } catch (e) {
      return new Error(String(e));
    }
  }
}
